// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";
import { FaLocationDot } from "react-icons/fa6";
import { ENQUIRY_CTA } from "../constants";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="Assets/banner1.png"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            About Capria East at Ghaf Woods
          </h2>
          {/* <div className="luxury-location flex items-center">
            <FaLocationDot className="text-[#997736] mr-2" />
            <span className="text-[#997736] font-bold text-lg">Ghaf Woods, Dubai</span>
          </div> */}
          <p>
            Capria East at Ghaf Woods, developed by the renowned Majid Al Futtaim, represents the pinnacle of modern eco-luxury living in Dubai. This premium residential development seamlessly blends contemporary architecture with lush green spaces, offering residents breathtaking views of both forest and cityscapes. Inspired by the iconic Ghaf tree, the design reflects a commitment to sustainability and harmony with nature, creating a living environment that is both people-friendly and planet-conscious. Nestled within the serene Ghaf Woods community, Capria East provides a unique lifestyle that combines the tranquility of nature with the convenience of urban living, making it an ideal choice for those seeking a peaceful yet connected life in Dubai.
          </p>
          <button onClick={() => openModal(ENQUIRY_CTA.INTRO)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
